import React from "react";
import { TextField, Button, Typography, Box } from "@mui/material";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { useNavigate } from "react-router-dom";
import FooterNav from "./FooterNav";


// Validation schema with Yup
const validationSchema = Yup.object({
  firstName: Yup.string().required("First Name is required"),
  lastName: Yup.string().required("Last Name is required"),
  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),
  donationAmount: Yup.number()
    .positive("Donation must be a positive number")
    .required("Donation Amount is required"),
});

const Charity = () => {
  // Handle form submission
    const navigate = useNavigate();
  const handleSubmit = (values, { resetForm }) => {
    const { donationAmount } = values;
    toast.success("Thank you for your donation!");

    // Simulate adding donation to the total
    setTimeout(() => {
      // Reset the form after submission
      resetForm();
    }, 2000);
  };

  return (
    <>
     <div style={{ width: "100%", }}>
       <Box
          sx={{
            display: "flex",
            padding: 1,
            justifyContent: "space-between",
            alignItems: "center",
            background: "#f83600",
            marginBottom: 1,
          }}
        >
          <Box onClick={() => navigate(-1)} style={{ textDecoration: "none" }}>
            <ChevronLeftIcon
              fontSize="medium"
              style={{
                // width: "60px",
                color: "#fff",
                border: "1px solid #f2f3f5",
                borderRadius: 50,
              }}
            />
          </Box>
          <Typography variant="subtitle2" color="#fff">
            Charity
          </Typography>
          <Box> </Box>
        </Box>
 
    <Box
      sx={{
        padding: 2,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Typography variant="h4" color='secondary.light' gutterBottom sx={{ textAlign: 'center', }}>
        Donate & Help African Children for Education
      </Typography>

      {/* Formik form */}
      <Formik
        initialValues={{
          firstName: "",
          lastName: "",
          email: "",
          donationAmount: "",
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, handleChange, touched, errors }) => (
          <Form
            style={{
                background:'#fff',
                borderRadius:"10px",
                padding:"10px",
                width:'80%',
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {/* First Name */}
            <Field
              as={TextField}
              label="First Name"
              name="firstName"
              size='small'
              variant="outlined"
              value={values.firstName}
              onChange={handleChange}
              fullWidth
              error={touched.firstName && Boolean(errors.firstName)}
              helperText={touched.firstName && errors.firstName}
              sx={{ marginBottom: 2 }}
            />

            {/* Last Name */}
            <Field
              as={TextField}
              size='small'
              label="Last Name"
              name="lastName"
              variant="outlined"
              value={values.lastName}
              onChange={handleChange}
              fullWidth
              error={touched.lastName && Boolean(errors.lastName)}
              helperText={touched.lastName && errors.lastName}
              sx={{ marginBottom: 2 }}
            />

            {/* Email Address */}
            <Field
              as={TextField}
              size='small'
              label="Email Address"
              name="email"
              variant="outlined"
              value={values.email}
              onChange={handleChange}
              fullWidth
              type="email"
              error={touched.email && Boolean(errors.email)}
              helperText={touched.email && errors.email}
              sx={{ marginBottom: 2 }}
            />

            {/* Donation Amount */}
            <Field
              as={TextField}
              size='small'
              label="Donation Amount"
              name="donationAmount"
              variant="outlined"
              value={values.donationAmount}
              onChange={handleChange}
              fullWidth
              type="number"
              error={touched.donationAmount && Boolean(errors.donationAmount)}
              helperText={touched.donationAmount && errors.donationAmount}
              sx={{ marginBottom: 2 }}
            />

            {/* Submit Button */}
            <Button
              variant="contained"
              color="primary"
              type="submit"
              sx={{ marginBottom: 2 }}
            >
              Donate
            </Button>
          </Form>
        )}
      </Formik>

      {/* Toast Notifications */}
      <ToastContainer />
    </Box>
    </div>
    <FooterNav />
    </>
  );
};

export default Charity;
